export default __webpack_public_path__ + "static/media/login-circle.b3b98873.svg";